export default __webpack_public_path__ + "static/media/ke.cb5cdf8e.svg";